export const SUPPORTED_LANGUAGES = {
    en: 'English',
    es: 'Spanish',
    de: 'German',
    fr: 'French',
    it: 'Italian',
    pt: 'Portuguese',
    ru: 'Russian',
};
